<template>
<v-container class="fill-height data-container" fluid>
    <span class="rank-change-disabled" v-if="!rankSortAsc">Rank changing arrows are only allowed when sorting by <span class="click" @click="sortByRank">"Rank" ascending.</span></span>
    <div id="ag-grid-container" :class="{'rank-change-disabled': !rankSortAsc}">
        <ag-grid-vue style="width: 100%; height: 100%;" class="ag-theme-balham" v-if="showGrid"
            :gridOptions="gridOptions"
            @row-double-clicked="(params) => $emit('edit', params.data)"
            :groupHeaders="true"
            :scrollbarWidth="20"
            :rowHeight="40">
        </ag-grid-vue>
    </div>

</v-container>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "../../../node_modules/ag-grid-community/dist/styles/ag-grid.css";
import "../../../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css";
export default {
    name: 'AlarmModificationsList',
    props: ['alarmModsList', 'lockSave'],
    components: {
    'ag-grid-vue': AgGridVue,
    },
    data: () => ({
        showGrid: false,
        gridOptions: null,
        rankSortAsc: true,
    }),

    computed: {

    },

    methods: {
        buildAgGrid: function() {
            this.showGrid = false;
            this.gridOptions = {};
            this.gridOptions.rowData = this.$props.alarmModsList;
            this.gridOptions.columnDefs = this.createColumnDefs();

            let self = this;
            this.gridOptions.onGridReady = function(params) {
                self.sortByRank();
                self.gridOptions.api.hideOverlay();
                let allColIds = params.columnApi.getAllColumns().map(column => column.colId);
                allColIds.splice(0, 1);
                self.gridOptions.columnApi.autoSizeColumns(allColIds);
                //self.gridOptions.api.sizeColumnsToFit();
            }
            this.gridOptions.onSortChanged = function(params) {
                let sortList = params.api.getSortModel()
                if(sortList.length == 1 && sortList[0].colId == 'modif_rank' && sortList[0].sort == 'asc') {
                    self.rankSortAsc = true;
                }
                else {
                    self.rankSortAsc = false;
                }
                self.gridOptions.api.redrawRows();
            }

            this.gridOptions.getContextMenuItems = function() {
                return [
                    'copy',
                    'copyWithHeaders',
                    'paste',
                    'csvExport',
                    'excelExport',
                    {
                        name: 'AI Analyser',
                        disabled: !self.$store.state.batchConfig.webapp_openai,
                        action: function() {
                            self.$store.commit('setAiAnalyzerContext', 'alarmMods');
                            self.$store.commit('setAiAnalyzerGridAPI', self.gridOptions.api);
                            self.$store.commit('setShowAIAnalyzer', true);
                        },
                        icon: `<i data-v-10101010101="" aria-hidden="true" class="v-icon notranslate mdi mdi-lightning-bolt theme--dark"></i>`
                    },
                ];
            };

            // Set the row text color if the current time is outside the rules active times.
            this.gridOptions.getRowStyle = function(params) {
                if(!!params.data.modif_active_starting && !!params.data.modif_active_until) {
                    let start = TELSA.moment(params.data.modif_active_starting);
                    let end = TELSA.moment(params.data.modif_active_until);
                    let current = TELSA.moment.tz(self.$store.state.batchConfig.timezone);
                    if(current < start) { // Rule hasnt started yet
                        return {
                            fontWeight: 'bold',
                            color: 'limegreen'
                        };
                    }
                    if(current > end) { // Rule has expired
                        return {
                            fontWeight: 'bold',
                            color: 'red'
                        };
                    }
                    // Otherwise the rule is active now
                }
            }

            this.gridOptions.defaultColDef = {
                sortable: true,
                filter: true,
                resizable: true
            }
            this.showGrid = true;
        },

        createColumnDefs: function() {
            let columnDefs = [];
            const self = this;
            columnDefs = [
                { 
                    headerName: '', 
                    suppressSizeToFit: true,
                    width: 210, 
                    filter: 'text', cellStyle: {'padding-top': '5px', 'text-align': 'left', 'background-color': 'white', 'border-right': 'black solid 1px'},
                    cellRenderer: class {
                        init(params) {
                            this.params = params;
                            this.isTop = params.data.modif_rank == 1;
                            this.isBottom = params.data.modif_rank == self.$props.alarmModsList.length;

                            this.eGui = document.createElement('div');
                            this.eGui.innerHTML = `<span class="mdi mdi-pencil-circle alarm-mods-list-action" style="cursor: pointer; color: #c42111; font-size: 20pt" />
                                <span class="mdi mdi-delete-circle alarm-mods-list-action" style="cursor: ${self.$props.lockSave ? 'default' : 'pointer'}; color: ${self.$props.lockSave ? '#E0E0E0' : '#c42111'}; font-size: 20pt" />
                                <span class="mdi mdi-arrow-up-circle alarm-mods-list-action" style="cursor: ${(this.isTop || !self.rankSortAsc) ? 'default' : 'pointer'}; color: ${(this.isTop || !self.rankSortAsc) ? '#E0E0E0' : '#c42111'}; font-size: 20pt" />
                                <span class="mdi mdi-arrow-down-circle alarm-mods-list-action" style="cursor: ${(this.isBottom || !self.rankSortAsc) ? 'default' : 'pointer'}; color: ${(this.isBottom || !self.rankSortAsc) ? '#E0E0E0' : '#c42111'}; font-size: 20pt" />
                                <span class="mdi mdi-alpha-m-circle alarm-mods-list-action" style="cursor: pointer; color: #c42111; font-size: 20pt" />
                                <span class="mdi mdi-content-copy alarm-mods-list-action" style="cursor: ${self.$props.lockSave ? 'default' : 'pointer'}; color: ${self.$props.lockSave ? '#E0E0E0' : '#c42111'}; font-size: 20pt" />`;
                            
                            this.editButtonHandler = this.editButtonHandler.bind(this);
                            this.deleteButtonHandler = this.deleteButtonHandler.bind(this);
                            this.moveUpButtonHandler = this.moveUpButtonHandler.bind(this);
                            this.moveDownButtonHandler = this.moveDownButtonHandler.bind(this);
                            this.moveCustomButtonHandler = this.moveCustomButtonHandler.bind(this);
                            this.cloneButtonHandler = this.cloneButtonHandler.bind(this);

                            this.editButton = this.eGui.querySelectorAll('.alarm-mods-list-action')[0];
                            this.deleteButton = this.eGui.querySelectorAll('.alarm-mods-list-action')[1];
                            this.moveUpButton = this.eGui.querySelectorAll('.alarm-mods-list-action')[2];
                            this.moveDownButton = this.eGui.querySelectorAll('.alarm-mods-list-action')[3];
                            this.moveCustomButton = this.eGui.querySelectorAll('.alarm-mods-list-action')[4];
                            this.cloneButton = this.eGui.querySelectorAll('.alarm-mods-list-action')[5];

                            this.editButton.addEventListener('click', this.editButtonHandler);
                            this.deleteButton.addEventListener('click', this.deleteButtonHandler);
                            this.moveUpButton.addEventListener('click', this.moveUpButtonHandler);
                            this.moveDownButton.addEventListener('click', this.moveDownButtonHandler);
                            this.moveCustomButton.addEventListener('click', this.moveCustomButtonHandler);
                            this.cloneButton.addEventListener('click', this.cloneButtonHandler);
                        }
                        getGui() {
                            return this.eGui;
                        }
                        editButtonHandler(event) {
                            event.stopPropagation();
                            this.params.editFunction(this.params);
                        }
                        deleteButtonHandler(event) {
                            event.stopPropagation();
                            this.params.deleteFunction(this.params);
                        }
                        moveUpButtonHandler(event) {
                            event.stopPropagation();
                            this.params.moveUpFunction(this.params, this.isTop);
                        }
                        moveDownButtonHandler(event) {
                            event.stopPropagation();
                            this.params.moveDownFunction(this.params, this.isBottom);
                        }
                        moveCustomButtonHandler(event) {
                            event.stopPropagation();
                            this.params.moveCustomFunction(this.params);
                        }
                        cloneButtonHandler(event) {
                            event.stopPropagation();
                            this.params.cloneFunction(this.params);
                        }
                        destroy() {
                            this.editButton.removeEventListener('click', this.editButtonHandler);
                            this.deleteButton.removeEventListener('click', this.deleteButtonHandler);
                            this.moveUpButton.removeEventListener('click', this.moveUpButtonHandler);
                            this.moveDownButton.removeEventListener('click', this.moveDownButtonHandler);
                            this.moveCustomButton.removeEventListener('click', this.moveCustomButtonHandler);
                            this.cloneButton.removeEventListener('click', this.cloneButtonHandler);
                        }
                    },
                    cellRendererParams: {
                        editFunction: (params) => {
                            this.$emit('edit', params.data);
                        },
                        deleteFunction: (params) => {
                            if(!self.$props.lockSave) {
                                this.deleteAlarmModClick(params.data);
                            }
                        },
                        moveUpFunction: (params, isTop) => {
                            if(!isTop && self.rankSortAsc) {
                                this.moveUp(params.data);
                            }
                        },
                        moveDownFunction: (params, isBottom) => {
                            if(!isBottom && self.rankSortAsc) {
                                this.moveDown(params.data);
                            }
                        },
                        moveCustomFunction: (params) => {
                            this.$emit("moveToClick", params.data);
                        },
                        cloneFunction: (params) => {
                            if(!self.$props.lockSave) {
                                this.$emit("clone", params.data);
                            }
                        }
                    }
                },
                { 
                    headerName: 'Rank', 
                    field: 'modif_rank',
                    //width: 150, 
                    filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                },
                { 
                    headerName: 'Office', 
                    field: 'modif_office', 
                    //width: 150, 
                    filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'} 
                },
                { 
                    headerName: 'Location', 
                    field: 'modif_location', 
                    //width: 150, 
                    filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'} 
                },
                { 
                    headerName: 'Locale', 
                    field: 'modif_locale', 
                    //width: 150, 
                    filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'} 
                },
                { 
                    headerName: 'Code/Phrase', 
                    field: 'modif_code', 
                    //width: 150, 
                    filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'} 
                },
                { 
                    headerName: 'Sev', 
                    field: 'modif_orig_severity', 
                    //width: 150, 
                    filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'} 
                },
                { 
                    headerName: 'Rep', 
                    field: 'modif_repeats', 
                    //width: 150, 
                    filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'} 
                },
                { 
                    headerName: 'Occurs', 
                    field: 'modif_bounce_times', 
                    //width: 150, 
                    filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'} 
                },
                { 
                    headerName: 'After Time', 
                    field: 'modif_after_time', 
                    //width: 150, 
                    filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'} 
                },
                { 
                    headerName: 'Before Time', 
                    field: 'modif_before_time', 
                    //width: 150, 
                    filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'} 
                },
                { 
                    headerName: 'Facility Type', 
                    field: 'modif_facility_type', 
                    //width: 150, 
                    filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'} 
                },
                { 
                    headerName: 'DOW', 
                    //width: 150, 
                    filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    valueGetter: function(params) {
                        let dayString = '';
                        dayString += (params.data.modif_days_sun ? 'Su' : '');
                        dayString += (params.data.modif_days_mon ? 'M' : '');
                        dayString += (params.data.modif_days_tue ? 'Tu' : '');
                        dayString += (params.data.modif_days_wed ? 'W' : '');
                        dayString += (params.data.modif_days_thu ? 'Th' : '');
                        dayString += (params.data.modif_days_fri ? 'F' : '');
                        dayString += (params.data.modif_days_sat ? 'Sa' : '');
                        return dayString;
                    }
                },
                { 
                    headerName: 'Stop', 
                    //width: 150, 
                    filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    valueGetter: function(params) {
                        return params.data.modif_stop_if_matches ? 'Yes': 'No';
                    }
                },
                { 
                    headerName: 'Modification', 
                    field: 'site_name', 
                    //width: 150, 
                    filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    valueGetter: function(params) {
                        let modString = '';
                        modString += `${!!params.data.modif_disregard ? 'DIS, ' : ''}`;
                        modString += `${!!params.data.modif_change_severity ? `${params.data.modif_change_severity}, ` : ''}`;
                        modString += `${!!params.data.modif_shakeout ? `${params.data.modif_shakeout}, ` : ''}`;
                        modString += `${!!params.data.modif_text ? `TEXT ${params.data.modif_text}, ` : ''}`;
                        modString += `${!!params.data.modif_clear_iff_acked ? 'ClearOnlyAcked, ' : ''}`;
                        modString += `${!!params.data.modif_clear_never ? 'ClearNever, ' : ''}`;
                        modString += `${!!params.data.modif_clear_after_min ? `ClearIn-${params.data.modif_clear_after_min}, ` : ''}`;
                        modString += `${!!params.data.modif_service_affecting ? 'ServiceAffecting, ' : ''}`;
                        if(modString) {
                            modString = modString.slice(0, -2);
                        }
                        return modString;
                    }
                },
            ];
            return columnDefs;
        },

        moveUp: function(alarmMod) {
            this.swapAlarmMods(this.$props.alarmModsList.indexOf(alarmMod), (this.$props.alarmModsList.indexOf(alarmMod) - 1));
        },

        moveDown: function(alarmMod) {
            this.swapAlarmMods(this.$props.alarmModsList.indexOf(alarmMod), (this.$props.alarmModsList.indexOf(alarmMod) + 1));
        },

        swapAlarmMods: function(idx1, idx2) {
            let temp = this.$props.alarmModsList[idx1];
            this.$props.alarmModsList[idx1] = this.$props.alarmModsList[idx2];
            this.$props.alarmModsList[idx2] = temp;
            for(const [idx, am] of this.$props.alarmModsList.entries()) {
                am.modif_rank = (idx + 1);
            }
            this.gridOptions.api.setRowData(this.$props.alarmModsList);
            this.$store.commit('setIsDirty', true);
            this.$nextTick(function() {
                this.gridOptions.api.ensureIndexVisible(idx1, 'middle');
            });
        },

        sortByRank: function() {
            this.gridOptions.api.setSortModel([{colId: 'modif_rank', sort: 'asc'}]);
            this.rankSortAsc = true;
        },

        deleteAlarmModClick: function(alarmMod) {
            let idx = this.$props.alarmModsList.indexOf(alarmMod);
            this.$emit('delete', alarmMod);
            this.$nextTick(function() {
                if(idx >= this.$props.alarmModsList.length) {
                    idx = this.$props.alarmModsList.length - 1;
                }
                this.gridOptions.api.ensureIndexVisible(idx, 'middle');
            });
        }

    },

    watch: {
        alarmModsList: {
            handler(newVal, oldVal) {
                if(!this.$props.lockSave) {
                    this.$store.commit('setIsDirty', true);
                }
                let filters = this.gridOptions.api.getFilterModel();
                this.gridOptions.api.setRowData(this.$props.alarmModsList);
                this.gridOptions.api.setFilterModel(filters);
            },
            deep: true
        }
    },

    mounted() {
        this.buildAgGrid();
    }

  
};
</script>

<style scoped>

    #ag-grid-container {
        height: calc(100vh - 126px);
    }
    #ag-grid-container.rank-change-disabled {
        height: calc(100vh - 178px);
    }

    .rank-change-disabled {
        display: block;
        color: #ff5252;
        margin-top: -5px;
        margin-bottom: 15px;
    }
    .rank-change-disabled .click {
        cursor: pointer;
        text-decoration: underline;
    }

</style>
